import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=4b42ad62&"
import script from "./atendimentos.js?vue&type=script&lang=js&"
export * from "./atendimentos.js?vue&type=script&lang=js&"
import style0 from "./Atendimentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports